<template>
  <div class="header-breadcrumbs-desktop screen">
    <div class="bread_crumbs-4">
      <div class="bread_crumbs-item" @click="clickBreadCrumbs(1)">
        <div class="jugadores avenirnextltpro-medium-big-stone-19-4px">
          Jugadores - Equipo
        </div>
      </div>
      <Division2 />
      <div class="bread_crumbs-item" @click="clickBreadCrumbs(2)">
        <div class="jugadores avenirnextltpro-medium-big-stone-19-4px">
          Jugadores - Plantilla
        </div>
      </div>
      <Division2 />
      <div class="bread_crumbs-item">
        <div class="perfil-jugador-4">Perfil jugador</div>
      </div>
    </div>
    <header class="header-4">
      <div class="header_container-4">
        <div class="player_data-4">
          <div class="photo-club-4">
            <div class="foto_-container-4">
              <img
                class="foto_jugador-4"
                v-if="player.player_photo"
                :src="player.player_photo"
                alt="foto_jugador"
              /><img class="foto_club-4" v-if="player.team_logo" :src="player.team_logo" alt="foto_club" />
            </div>
          </div>
          <div class="info-4">
            <div class="info_container-4">
              <div class="name-4">
                <h1 class="title-1 valign-text-middle">{{ playerName }}</h1>
              </div>
              <div class="container_info-4">
                <div class="nationality-age-4">
                  <img class="country-flag-4" v-if="player.flag" :src="player.flag" alt="country-flag" />
                  <div class="nationality-age-item-4 valign-text-middle avenirnextltpro-demi-normal-white-18px">
                    {{ playerNationality }}
                  </div>
                  <div
                    class="nationality-age-item-4 valign-text-middle avenirnextltpro-light-white-18px"
                    v-if="player.dob"
                  >
                    |
                  </div>
                  <div
                    class="nationality-age-item-4 valign-text-middle avenirnextltpro-demi-normal-white-18px"
                    v-if="player.dob"
                  >
                    {{ player.dob | toAge }} {{ $t('player.years_old') }}
                  </div>
                </div>
              </div>
              <div class="container_data">
                <div class="nationality-data">
                  <div class="cont-text-subheader">
                    <div class="cont-text-subheader__title">Posición:</div>
                    <div class="cont-text-subheader__val">{{ playerPosition }}</div>
                  </div>
                  <div class="sep-data-line"></div>
                  <div class="cont-text-subheader">
                    <div class="cont-text-subheader__title">Partidos jugados:</div>
                    <div class="cont-text-subheader__val">{{ player.games_played }}</div>
                  </div>
                  <div class="sep-data-line"></div>
                  <div class="cont-text-subheader">
                    <div class="cont-text-subheader__title">Minutos jugados:</div>
                    <div class="cont-text-subheader__val">{{ player.minutes_played }}</div>
                  </div>
                  <div class="sep-data-line"></div>
                  <div class="cont-text-subheader">
                    <div class="cont-text-subheader__title">Torneo:</div>
                    <div class="cont-text-subheader__val">{{ nameSeasonSelected }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header_info_menu-4">
          <div class="btn-5" :class="value === 4 ? 'active' : ''" @click="onChangeSection(4)">
            <img class="icon-clock" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen@2x.png" />
            <div class="resumen-4 valign-text-middle avenirnextltpro-demi-normal-white-11-6px">RESUMEN</div>
          </div>
          <div
            class="btn-5"
            v-on:mouseover="isHover = true"
            v-on:mouseleave="isHover = false"
            :class="value === 1 ? 'active' : ''"
            @click="onChangeSection(1)"
          >
            <img
              v-if="!isHover && value != 1"
              class="icn_posesion-3"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_normal@2x.png"
            />
            <img
              v-else
              class="icn_posesion-3"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_hover@2x.png"
            />
            <div class="posesin-4 valign-text-middle avenirnextltpro-demi-normal-white-11-6px">POSESIÓN</div>
          </div>
          <div class="btn-5" :class="value === 2 ? 'active' : ''" @click="onChangeSection(2)">
            <img class="icn-3" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_ofensivo@2x.png" />
            <div class="ofensivo-3 valign-text-middle avenirnextltpro-demi-normal-white-11-6px">OFENSIVO</div>
          </div>
          <div class="btn-5" :class="value === 3 ? 'active' : ''" @click="onChangeSection(3)">
            <img class="icn-3" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_defensivo@2x.png" />
            <div class="defensivo-3 valign-text-middle avenirnextltpro-demi-normal-white-11-6px">DEFENSIVO</div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import playerHeaderMixin from '@/utils/mixins/player-header';
import Division2 from '@/components/Sections/HeaderFigma/Division2';
export default {
  name: 'HeaderBreadcrumbsDesktop',
  components: {
    Division2,
  },
  props: {
    player: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      isHover: false,
      section: 4,
      nameSeasonSelected: '',
      sections: [
        {
          id: 4,
          title: 'analysis_type.summary',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen_unselected.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen.svg',
          ],
          selected: false,
        },
        {
          id: 1,
          title: 'analysis_type.possession',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-white.svg',
          ],
          selected: false,
        },
        {
          id: 2,
          title: 'analysis_type.offensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-white.svg',
          ],
          selected: false,
        },
        {
          id: 3,
          title: 'analysis_type.defensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-white.svg',
          ],
          selected: false,
        },
      ],
    };
  },
  mounted() {
    this.changeSection(this.value);
  },
  computed: {
    ...mapGetters('playersGeneral', ['lastTeamPlayersView', 'lastTeamNamePlayersView']),
    ...mapState('filterGeneral', [
      'seasons',
      'hasPlayerNationalTeam',
      'isPlayerNationalTeam',
      'nationalSeasons',
      'hasPlayerClubSeasons',
    ]),
    ...mapGetters('filterGeneral', {
      seasonId: 'getSeasonId',
    }),
    ...mapGetters('loginGeneral', ['getTournamentsNameSelected', 'getSeasonsNameSelected']),
    sectionsIds() {
      return this.sections.map(i => i.id);
    },
  },
  methods: {
    ...mapMutations('filterGeneral', ['setStadisticId', 'setIsPlayerNationalTeam']),
    clickBreadCrumbs(id) {
      if (id == 1) {
        this.$router.push('/playersAnalysis/teams');
      }
      if (id == 2) {
        this.$router.push(
          `/playersAnalysis/teams/` +
            window.localStorage.getItem('LTeamForPlayersView') +
            `?teamName=` +
            window.localStorage.getItem('LTeamNameForPlayersView'),
        );
      }
    },
    changeSection(sectionId) {
      if (this.sectionsIds.includes(sectionId)) {
        this.sections.forEach(e => (e.selected = false));
        const section = this.sections.find(s => s.id === sectionId);
        if (section) {
          section.selected = true;
          return true;
        }
      }
      return false;
    },
    onChangeSection(id) {
      this.section = id;
      let result = this.changeSection(id);
      if (result) this.$emit('input', id);
    },
  },
  watch: {
    player: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          const selectedSeason = this.seasons.find(season => season.id === this.seasonId);
          if (this.isPlayerNationalTeam) {
            const nationalSeason = newValue.national_seasons[selectedSeason.id];
            this.nameSeasonSelected = nationalSeason ? nationalSeason.name : '';
          } else if (newValue.seasons_v2) {
            this.nameSeasonSelected = newValue.seasons_v2[selectedSeason.id];
          } else if (newValue.seasons && newValue.seasons[selectedSeason.id]) {
            this.nameSeasonSelected = newValue.seasons[selectedSeason.id].alt_name;
          }
        }
      },
    },
    seasons() {
      if (this.player) {
        if (this.player.seasons_v2) {
          const selectedSeason = this.seasons.find(season => season.id === this.seasonId);
          if (this.isPlayerNationalTeam) {
            this.nameSeasonSelected = this.player.national_seasons[selectedSeason.id];
          } else {
            this.nameSeasonSelected = this.player.seasons_v2[selectedSeason.id];
          }
        }
      }
    },
    seasonId() {
      if (this.player) {
        if (this.player.seasons_v2) {
          const selectedSeason = this.seasons.find(season => season.id === this.seasonId);
          if (this.isPlayerNationalTeam) {
            this.nameSeasonSelected = this.player.national_seasons[selectedSeason.id];
          } else {
            this.nameSeasonSelected = this.player.seasons_v2[selectedSeason.id];
          }
        }
      }
    },
    value(newId) {
      this.changeSection(newId);
    },
  },
  mixins: [playerHeaderMixin],
};
</script>
<style scoped lang="scss">
.headerfigma .container_data {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 14px;
  width: auto;
  margin-bottom: -20px;
  position: relative;
}
.headerfigma .nationality-data {
  align-items: center;
  display: flex;
  gap: 7.2px;
  position: relative;
  width: auto;
}
.sep-data-line {
  width: 0.3px;
  align-self: stretch;
  flex-grow: 0;
  background-color: rgba(255, 255, 255, 0.51);
}
.cont-text-subheader {
  height: 16px;
  position: relative;
  min-width: auto;
  // background: red;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: -0.14px;
  text-align: left;
  color: #fff;
  display: inline-flex;
  @media screen and (max-width: 1600px) {
    display: inline-block;
    height: 30px;
    font-size: 11px;
  }
  &__title {
    width: auto;
    font-family: 'Avenir-Regular';
    // background: green;
    text-align: left;
    align-self: stretch;
    padding-right: 5px;
    display: inline-block;
    @media screen and (max-width: 1600px) {
      display: flex;
    }
  }
  &__val {
    width: auto;
    font-family: 'Avenir-Demi';
    // background: rgb(198, 241, 40);
    align-self: stretch;
    text-align: left;
    display: inline-block;
    @media screen and (max-width: 1600px) {
      display: flex;
    }
  }
}
</style>
<style scoped lang="css">
.headerfigma .active {
  background-color: #23b0ff !important;
}
:root {
  --big-stone: #132739;
  --black: #000000;
  --dodger-blue: #23b0ff;
  --white: #ffffff;

  --font-size-l: 11.6px;
  --font-size-m: 10px;
  --font-size-s: 6px;
  --font-size-xl: 16px;
  --font-size-xxl: 18px;
  --font-size-xxxl: 19.4px;
  --font-size-xxxxl: 24px;

  --font-family-avenir_next_lt_pro-bold: 'Avenir-Bold';
  --font-family-avenir_next_lt_pro-demi: 'Avenir-Demi';
  --font-family-avenir_next_lt_pro-light: 'Avenir-Regular';
  --font-family-avenir_next_lt_pro-medium: 'Avenir-Demi-Medium';
}
.headerfigma .avenirnextltpro-demi-normal-white-6px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-s);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-demi-normal-white-10px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-light-white-10px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-light);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 300;
}

.headerfigma .avenirnextltpro-medium-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 500;
}

.headerfigma .avenirnextltpro-demi-normal-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-bold-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 700;
}

.headerfigma .avenirnextltpro-demi-normal-white-18px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-demi-normal-white-11-6px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-l);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-bold-white-16px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xl);
  font-style: normal;
  font-weight: 700;
}

.headerfigma .avenirnextltpro-light-white-18px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-light);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 300;
}

.headerfigma .avenirnextltpro-medium-big-stone-19-4px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: var(--font-size-xxxl);
  font-style: normal;
  font-weight: 500;
}

.headerfigma .avenirnextltpro-demi-normal-big-stone-19-4px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxxl);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .screen a {
  display: contents;
  text-decoration: none;
}

.headerfigma .valign-text-middle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  white-space: pre-line;
  text-align: left;
}

.headerfigma * {
  box-sizing: border-box;
}
.headerfigma .header-breadcrumbs-desktop {
  align-items: center;
  border: 1.94px none;
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 100%;
  position: relative;
  margin-top: -8px;
}

.headerfigma .bread_crumbs-4 {
  align-items: center;
  align-content: center;
  display: flex;
  height: 25px;
  justify-content: left;
  padding: 0px 0px 0px 7.74px;
  position: relative;
  width: 1270px;
  margin: 0 auto;
}

.headerfigma .bread_crumbs-item {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 19.35px;
  padding: 3.87px 7.74px;
  position: relative;
  width: fit-content;
}

.headerfigma .jugadores {
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  position: relative;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}
.headerfigma .jugadores:hover {
  color: #23b0ff;
  cursor: pointer;
}

.headerfigma .perfil-jugador-4 {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xxxl);
  font-weight: 700;
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .header-4 {
  align-items: center;
  align-self: stretch;
  background: linear-gradient(
    180deg,
    rgb(6.85, 91.11, 137.06) 0%,
    rgba(1.63, 68.84, 105.5, 1) 51.8%,
    rgba(1.42, 14.25, 21.25, 1) 100%
  );
  /* background-color: transparent; */
  border-radius: 15.87px;
  display: flex;
  gap: 9.33px;
  height: 197px;
  /* mix-blend-mode: normal; */
  padding: 7.74px 23.23px 13.07px;
  position: relative;
}

.headerfigma .header_container-4 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  justify-content: space-between;
  position: relative;
}

.headerfigma .player_data-4 {
  align-items: flex-start;
  display: flex;
  gap: 27.1px;
  position: relative;
  width: fit-content;
}

.headerfigma .photo-club-4 {
  height: 131.12px;
  min-width: 125.32px;
  position: relative;
}

.headerfigma .foto_-container-4 {
  height: 133px;
  left: -6px;
  position: relative;
  width: 133px;
}

.headerfigma .foto_jugador-4 {
  height: 123px;
  left: 47px;
  object-fit: cover;
  position: absolute;
  top: 10px;
  width: 85px;
  border-radius: 12.2px;
  border: solid 3px #7ed321;
}

.headerfigma .foto_club-4 {
  height: 46px;
  left: 25px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 46px;
}

.headerfigma .info-4 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 9.33px;
  height: 91.35px;
  justify-content: center;
  padding: 7.87px 0px 0px;
  position: relative;
  width: auto;
}

.headerfigma .info_container-4 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 20px;
  gap: 14.87px;
  position: relative;
}
@media screen and (max-width: 1600px) {
  .headerfigma .info_container-4 {
    margin-top: 23px;
  }
}

.headerfigma .name-4 {
  align-items: flex-start;
  display: flex;
  gap: 19.35px;
  padding: 5.81px 0px;
  position: relative;
  width: fit-content;
}

.headerfigma .title-1 {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: 50px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 38.7px;
  margin-top: -1.94px;
  position: relative;
  text-shadow: 0px 3.73px 3.73px #162b3436;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .container_info-4 {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 14px;
  margin-bottom: -3px;
  position: relative;
}

.headerfigma .nationality-age-4 {
  align-items: center;
  display: flex;
  gap: 11.2px;
  position: relative;
  width: fit-content;
}

.headerfigma .country-flag-4 {
  height: 20px;
  max-width: 20px;
  object-fit: cover;
  position: relative;
  border-radius: 20px;
}

.headerfigma .nationality-age-item-4 {
  letter-spacing: -0.18px;
  line-height: 14.9px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .header_info_menu-4 {
  align-items: center;
  align-self: stretch;
  border-radius: 11.2px;
  display: flex;
  gap: 11.61px;
  justify-content: flex-end;
  position: relative;
  width: fit-content;
}

.headerfigma .btn_resumen-4 {
  align-items: center;
  background-color: var(--dodger-blue);
  border-radius: 10.27px;
  display: flex;
  flex-direction: column;
  gap: 13.55px;
  height: 86px;
  justify-content: center;
  padding: 9.68px 0px;
  position: relative;
  width: 132px;
}

.headerfigma .icon-clock {
  height: 45.73px;
  margin-top: -0.32px;
  min-width: 45.73px;
  position: relative;
}

.headerfigma .resumen-4,
.headerfigma .posesin-4,
.headerfigma .ofensivo-3,
.headerfigma .defensivo-3 {
  letter-spacing: -0.35px;
  line-height: 7.7px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .btn-5 {
  align-items: center;
  border-radius: 10.3px;
  display: flex;
  flex-direction: column;
  gap: 13.55px;
  height: 86px;
  justify-content: center;
  padding: 9.68px 0px;
  position: relative;
  width: 132px;
  box-shadow: 0 0.9px 4.7px 0 rgba(27, 45, 63, 0.14);
  border: solid 0.9px #23b0ff;
}
.headerfigma .btn-5:hover {
  background-color: #23b0ff;
  cursor: pointer;
}

.headerfigma .icn_posesion-3 {
  height: 45.73px;
  margin-top: -0.32px;
  min-width: 71.92px;
  position: relative;
}

.headerfigma .icn-3 {
  height: 46.11px;
  margin-top: -0.69px;
  min-width: 73.42px;
  position: relative;
}
</style>
